import convert from 'color-convert';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { GridActionButton } from '../../Asset/common';
import { useSelector } from 'react-redux';

//   const ExcelJS = require('exceljs');
//   const saveAs = require('file-saver'); //
// let Setting = useSelector(state => state.Setting.Setting);
async function generateExcel(columnConfig, data, filename, Setting) {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');
    debugger
    const filteredColumns = columnConfig?.filter(column => column.IsHide == false);
    // const filteredColumns = columnConfig;
    let ColumnHeader = []
    let ExcelFooterBackCol = 'green';
    let ExcelFooterForeCol = 'skyblue';
    let ExcelHeaderBackCol = 'green';
    let ExcelHeaderForeCol = 'skyblue';


    const getColorHex = (colorName) => {
        const rgbColor = convert.keyword.rgb(colorName);
        const hexColor = convert.rgb.hex(rgbColor);
        return `${hexColor}`;
    };

    filteredColumns.forEach(column => {
        ColumnHeader.push({
            header: column.ExcelHeader !== undefined && column.ExcelHeader !== null && column.ExcelHeader !== ''
                ? column.ExcelHeader
                : column.DispName,
            key: column.field,
            width: column.size / 7,
            fill: {
                type: 'pattern',
                pattern: 'solid',
            },
            numFmt: column.Format && (column.Format === '0' || column.Format === '0.00') ? column.Format : undefined
        });
    });


    worksheet.columns = ColumnHeader

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: getColorHex(ExcelHeaderBackCol?.toLowerCase()) }
        };
        cell.font = {
            bold: true,
            color: { argb: getColorHex(ExcelHeaderForeCol?.toLowerCase()) }
        };
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };
    });

    // Apply AutoFilter to all columns
    worksheet.autoFilter = {
        from: { row: 1, column: 1 },
        to: { row: 1, column: filteredColumns.length },
    };

    data?.forEach((row) => {
        const worksheetRow = worksheet.addRow(row);
        worksheetRow.eachCell({ includeEmpty: true }, cell => {
            const columnIndex = cell._column._number - 1; // Get column index
            const column = filteredColumns[columnIndex];

            // Apply cell background color
            if (column && column.ExcelBackCol && column.ExcelBackCol != '') {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    // fgColor: { argb: "B5C18E" }
                    fgColor: { argb: getColorHex(column.ExcelBackCol?.toLowerCase()) }
                };
            }

            // Apply cell foreground color
            if (column && column.ExcelForecol && column.ExcelForecol != '') {
                cell.font = {
                    // color: { argb: "f2632a" }
                    color: { argb: getColorHex(column.ExcelForecol?.toLowerCase()) }
                };
            }

            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };

            // ✅ GENERAL TYPE REMOVE KARINE "NUMBER" MA CONVERT KARVU
            if ((!cell.numFmt || cell.numFmt === 'General') && !isNaN(cell.value)) {
                if (column.DispFormate == '0.00') {
                    cell.value = Number(cell.value); // Convert to Number
                    cell.numFmt = '0.00'; // Default to 2 decimal places
                }
            }

            if (column && column.field?.toLowerCase() === 'certno' && row.REPORTLINK) {
                cell.value = {
                    text: row.CERTNO,
                    hyperlink: row.REPORTLINK,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'videolink1' && row.VIDEOLINK1) {
                cell.value = {
                    text: row.VIDEOLINK1,
                    hyperlink: row.VIDEOLINK1,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'videolink2' && row.VIDEOLINK2) {
                cell.value = {
                    text: row.VIDEOLINK2,
                    hyperlink: row.VIDEOLINK2,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'photolink' && row.PHOTOLINK) {
                cell.value = {
                    text: row.PHOTOLINK,
                    hyperlink: row.PHOTOLINK,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'reportlink' && row.REPORTLINK) {
                cell.value = {
                    text: row.REPORTLINK,
                    hyperlink: row.REPORTLINK,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

        });
    });


    function getExcelColumnLetter(index) {
        let letter = '';
        while (index >= 0) {
            letter = String.fromCharCode((index % 26) + 65) + letter;
            index = Math.floor(index / 26) - 1;
        }
        return letter;
    }


    // worksheet.addRow([]);
    // Add Total Row
    const firstColumnField = filteredColumns.length > 0 ? filteredColumns[0].field : null;
    const totalRow = {};

    filteredColumns.forEach((column, index) => {
        const colLetter = String.fromCharCode(65 + index); // Convert index to Excel column letter (A, B, C...)

        if (column.ExcelFormula) {

            if (column.ExcelFormula.toUpperCase() === "COUNT") {
                totalRow[column.field] = {
                    formula: `COUNTA(${colLetter}2:${colLetter}${data.length + 1})`
                };
            }
            else if (column.ExcelFormula.toUpperCase() === "SUM") {
                totalRow[column.field] = {
                    formula: `SUM(${colLetter}2:${colLetter}${data.length + 1})`
                };
            }
            else {
                const [primaryColumn, dependentCols] = column.ExcelFormula.split('=');
                const dependentColumns = dependentCols.split(',')?.map(col => col.trim());

                const columnIndices = dependentColumns?.map(field =>
                    filteredColumns.findIndex(col => col.field.toUpperCase() === field)
                );

                if (columnIndices.includes(-1)) return; // Skip if column not found

                const colLetters = columnIndices?.map(idx => getExcelColumnLetter(idx));

                // Apply specific formula logic based on column type
                if (primaryColumn.toUpperCase() === "RATE") {
                    totalRow[primaryColumn] = {
                        formula: `SUM(${colLetters[0]}2:${colLetters[0]}${data.length + 1}) / SUM(${colLetters[1]}2:${colLetters[1]}${data.length + 1})`
                    };
                } else if (primaryColumn.toUpperCase() === "DISC") {

                    // totalRow[column.field] = {
                    //     formula: `=((SUM(${colLetters[0]}2:${colLetters[0]}${data.length + 1}) - SUM(${colLetters[1]}2:${colLetters[1]}${data.length + 1})) / SUM(${colLetters[0]}2:${colLetters[0]}${data.length + 1})) * 100`
                    // };

                    const [orateIndex, rateIndex, icaratIndex] = dependentColumns?.map(field =>
                        filteredColumns.findIndex(col => col.field.toUpperCase() === field)
                    );

                    const oamtColIndex = filteredColumns.length + 1;
                    const amtColIndex = filteredColumns.length + 2;

                    worksheet.getColumn(oamtColIndex).header = 'OAMT';
                    worksheet.getColumn(oamtColIndex).hidden = true;
                    worksheet.getColumn(amtColIndex).header = 'AMT';
                    worksheet.getColumn(amtColIndex).hidden = true;

                    for (let rowIndex = 2; rowIndex <= data.length + 1; rowIndex++) {

                        worksheet.getRow(rowIndex).getCell(oamtColIndex).value = {
                            formula: `${getExcelColumnLetter(orateIndex)}${rowIndex} * ${getExcelColumnLetter(icaratIndex)}${rowIndex}`
                        };
                        worksheet.getRow(rowIndex).getCell(amtColIndex).value = {
                            formula: `${getExcelColumnLetter(rateIndex)}${rowIndex} * ${getExcelColumnLetter(icaratIndex)}${rowIndex}`
                        };
                    }

                    const oamtColumnLetter = getExcelColumnLetter(oamtColIndex - 1);
                    const amtColumnLetter = getExcelColumnLetter(amtColIndex - 1);
                    totalRow[primaryColumn] = {
                        formula: `=((SUM(${oamtColumnLetter}2:${oamtColumnLetter}${data.length + 1})-SUM(${amtColumnLetter}2:${amtColumnLetter}${data.length + 1}))/SUM(${oamtColumnLetter}2:${oamtColumnLetter}${data.length + 1}))*100`
                    };

                } else if (primaryColumn.toUpperCase() === "ORATE") {
                    // Extract dependent columns from ExcelFormula
                    const columnIndices = dependentColumns?.map(field =>
                        filteredColumns.findIndex(col => col.field.toUpperCase() === field)
                    );

                    // Ensure we have at least two columns for multiplication
                    if (columnIndices.length >= 2) {
                        const colLetters = columnIndices?.map(idx => getExcelColumnLetter(idx));

                        // Find the column which contains "CARAT"
                        const caratIndex = columnIndices.find(idx => filteredColumns[idx].field.toUpperCase().includes("CARAT"));
                        if (caratIndex !== undefined) {
                            const caratColumnLetter = getExcelColumnLetter(caratIndex);

                            totalRow[primaryColumn] = {
                                formula: `SUMPRODUCT(${colLetters[0]}2:${colLetters[0]}${data.length + 1}, ${colLetters[1]}2:${colLetters[1]}${data.length + 1}) / SUM(${caratColumnLetter}2:${caratColumnLetter}${data.length + 1})`
                            };
                        }
                    }
                }
            }

            // Extract dependent columns from ExcelFormula




        }
    });

    // Append total row and make it bold
    const totalRowRef = worksheet.addRow(totalRow);
    totalRowRef.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: getColorHex(ExcelFooterBackCol?.toLowerCase()) }
    }
    totalRowRef.eachCell(cell => {
        cell.font = {
            bold: true, size: 14,
            color: { argb: getColorHex(ExcelFooterForeCol?.toLowerCase()) }
        };
        // cell.fill = {
        //     type: 'pattern',
        //     pattern: 'solid',
        //     fgColor: { argb: getColorHex(ExcelFooterBackCol.toLowerCase()) }
        // };
    });


    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, filename);
}

// module.exports = generateExcel;
export default generateExcel;
